import { css } from 'styled-components';

export const displayFlex = css`
  display: flex;
`;
export const flexRow = css`
  flex-direction: row;
`;
export const flexColumn = css`
  flex-direction: column;
`;
export const spaceBetween = css`
  justify-content: space-between;
`;
export const justifyCenter = css`
  justify-content: center;
`;
export const alignCenter = css`
  align-items: center;
`;
export const alignEnd = css`
  align-items: flex-end;
`;
export const alignStart = css`
  align-items: flex-start;
`;
export const flexGrow = css`
  flex-grow: 1;
`;
export const flex1 = css`
  flex: 1;
`;
